module.exports = __webpack_public_path__ + "img/download-app-cover.59776bee.png";